import React from "react";
import { BankDetails } from "../../interfaces/bank";
import { BankCard } from "./BankCard";
import { XIcon } from "../../assets/svgs/icons-svg";

export function FailedStep({ details, onEdit }: { details: BankDetails; onEdit: () => void }) {
  return (
    <div className="space-y-6">
      <h2 className="text-lg font-semibold text-gray-900">Verification Failed</h2>
      <BankCard details={details} />
      <div className="flex items-center gap-2.5 text-base text-gray-500">
        <span className="w-5 h-5 rounded-full bg-[#AC1C1E] flex items-center justify-center flex-shrink-0">
          <XIcon className="w-3 h-3 text-white" />
        </span>
        <span>Account name does not match estate details</span>
      </div>
      <div className="flex justify-end">
        <button
          onClick={onEdit}
          className="px-5 py-2 bg-gray-900 text-white rounded-lg text-sm font-medium hover:bg-gray-700 active:scale-95 transition-all duration-200"
        >
          Edit Bank Details
        </button>
      </div>
    </div>
  )
}